"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import DocumentThumbnail from "./document_thumbnail";
import reactUtils from "../react_utils";
import "../components/waiting_spinner";
import Auth from "../util/auth";
import { doctypeGroupings } from "./grouped_document_browser_model";
var bem = reactUtils.makeBem("document-thumbnail-list");
var RelatedDocumentList = React.createClass({
  propTypes: {
    documents: React.PropTypes.array.isRequired,
    variant: React.PropTypes.string,
    selectedPages: React.PropTypes.array.isRequired,
    setSelectedPages: React.PropTypes.func.isRequired,
    isDocumentGrouper: React.PropTypes.bool
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("related-container") }, /* @__PURE__ */ React.createElement("div", { className: bem("related-container-title") }, this.props.title), this.waitingSpinner(this.props.loading), this.props.documents.map(this.showDocument));
  },
  waitingSpinner: function(loading) {
    if (loading) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-thumbnail--loading" }, "Loading...");
    }
  },
  showDocument: function(document) {
    return /* @__PURE__ */ React.createElement(
      DocumentThumbnail,
      {
        document,
        key: document.id,
        variant: this.props.variant,
        onContextMenu: this.props.onContextMenu,
        pageSelected: this.props.pageSelected,
        selectedPages: this.props.selectedPages,
        isDocumentGrouper: this.props.isDocumentGrouper
      }
    );
  }
});
const doctypesAtTheStart = [
  "invoice",
  "rateConfirmation",
  "billOfLading",
  "deliveryReceipt",
  "customerRateCon"
];
const doctypesAtTheEnd = ["other"];
export default React.createClass({
  propTypes: {
    documents: React.PropTypes.array.isRequired,
    variant: React.PropTypes.string,
    selectedPages: React.PropTypes.array.isRequired,
    setSelectedPages: React.PropTypes.func.isRequired
  },
  renderEntries: function() {
    if (this.props.isDocumentGrouper || !Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled) {
      return _.map(this.documentsInSelectedGroups(), this.showDraggableThumbnailGroup);
    }
    const documentsInGroups = this.documentsInSelectedGroups();
    const documentTypes = _.groupBy(documentsInGroups, (document) => document[0].type);
    const sortedDocumentTypes = doctypeGroupings(this.props.documents);
    const entries = sortedDocumentTypes.map((type) => {
      const groupedDocuments = documentTypes[type].sort((a, b) => a[0].id - b[0].id);
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "document-thumbnail__title document-thumbnail__doctype" }, groupedDocuments[0][0].type_name), _.map(groupedDocuments, this.showDraggableThumbnailGroup));
    });
    return entries;
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem(this.props.variant) }, this.renderEntries(), this.possibleRelatedDocuments());
  },
  documentsInSelectedGroups: function() {
    let currentArray = [];
    const component = this;
    return _.reduce(this.props.documents, (memo, document) => {
      let isSelected = _.find(component.selectedPages(), (page) => page.id === document.pages[0].id);
      if (isSelected) {
        currentArray.push(document);
        if (currentArray.length === component.selectedPages().length) {
          memo.push(currentArray);
          currentArray = [];
        }
      } else {
        memo.push([document]);
      }
      return memo;
    }, []);
  },
  showDraggableThumbnailGroup: function(documents) {
    const key = "documents-" + documents.map((document) => document.id).join("-");
    return /* @__PURE__ */ React.createElement("div", { className: "draggable-thumbnail-group", key }, _.map(documents, this.showDocument));
  },
  showDocument: function(document) {
    return /* @__PURE__ */ React.createElement(
      DocumentThumbnail,
      {
        document,
        key: document.id,
        variant: this.props.variant,
        onContextMenu: this.props.onContextMenu,
        pageSelected: this.pageSelected,
        selectedPages: this.selectedPages(),
        isDocumentGrouper: this.props.isDocumentGrouper
      }
    );
  },
  noSelectedPages: function() {
    let pages = this.props.documents.map((document) => document.pages[0]);
    return _.isEmpty(_.intersection(pages, this.selectedPages()));
  },
  pageSelected: function(selectedPage, options = {}) {
    let { action } = options;
    if (action === "replace" || this.noSelectedPages()) {
      this.setSelectedPages([selectedPage], selectedPage);
    } else if (action === "add") {
      let pages = this.props.documents.map((document) => document.pages[0]);
      let anchorPageIndex = pages.indexOf(this.props.anchorPage);
      let selectedPageIndex = pages.indexOf(selectedPage);
      let minIndex = anchorPageIndex;
      let maxIndex = selectedPageIndex;
      if (selectedPageIndex < anchorPageIndex) {
        minIndex = selectedPageIndex;
        maxIndex = anchorPageIndex;
      }
      let selectedPages = pages.slice(minIndex, maxIndex + 1);
      this.setSelectedPages(selectedPages, this.props.anchorPage);
    }
  },
  setSelectedPages: function(selectedPages, anchorPage) {
    this.props.setSelectedPages(selectedPages, anchorPage);
  },
  selectedPages: function() {
    return this.props.selectedPages;
  },
  possibleRelatedDocuments: function() {
    if (this.props.relatedDocuments && this.props.relatedDocuments.length > 0) {
      return /* @__PURE__ */ React.createElement(
        RelatedDocumentList,
        __spreadProps(__spreadValues({}, this.props), {
          pageSelected: this.pageSelected,
          selectedPages: this.selectedPages(),
          loading: this.props.relatedDocumentsLoading,
          documents: this.props.relatedDocuments,
          title: this.props.relatedDocumentsTitle
        })
      );
    }
  }
});
